import RebasePath from './RebasePath';
import setTextColorBasedOnBg from './setTextColorBasedOnBg';

const setPrechatStyles = (root, preChatObject) => {
    const { preChat } = preChatObject;
    root.documentElement.style.setProperty(
        '--innerObjectBackgroundImage',
        RebasePath(preChat.handlerImageUrl)
    );
    root.documentElement.style.setProperty(
        '--innerObjectBorderColor',
        preChat.innerObject.borderColor
    );
    root.documentElement.style.setProperty('--innerObjectPadding', preChat.innerObject.padding);
    root.documentElement.style.setProperty(
        '--innerObjectBorderColor',
        preChat.innerObject.borderColor
    );
    root.documentElement.style.setProperty(
        '--innerObjectBorderWidth',
        preChat.innerObject.borderWidth
    );
    root.documentElement.style.setProperty('--innerObjectPadding', preChat.innerObject.padding);
    root.documentElement.style.setProperty(
        '--innerObjectBorderRadius',
        preChat.innerObject.borderRadius
    );
    root.documentElement.style.setProperty(
        '--outerObjectBackgroundImage',
        preChat.outerObject.backgroundImage
    );
    // root.documentElement.style.setProperty('--outerObjectBorderColor', preChat.outerObject.borderColor);
    root.documentElement.style.setProperty(
        '--outerObjectBorderWidth',
        preChat.outerObject.borderWidth
    );
    root.documentElement.style.setProperty('--outerObjectPadding', preChat.outerObject.padding);
    root.documentElement.style.setProperty(
        '--outerObjectBorderRadius',
        preChat.outerObject.borderRadius
    );
    root.documentElement.style.setProperty(
        '--messageCounterBackgroundColor',
        preChat.messageCounter.backgroundColor
    );
    root.documentElement.style.setProperty(
        '--messageCounterFontFamily',
        preChat.messageCounter.font.family
    );
    root.documentElement.style.setProperty(
        '--messageCounterFontSize',
        preChat.messageCounter.font.size
    );
    root.documentElement.style.setProperty(
        '--messageCounterFontColor',
        preChat.messageCounter.font.color
    );
    root.documentElement.style.setProperty(
        '--messagePopupBackgroundColor',
        preChat.messagePopup.backgroundColor
    );
    root.documentElement.style.setProperty(
        '--messagePopupBorderRadius',
        preChat.messagePopup.borderRadius
    );
    root.documentElement.style.setProperty('--messagePopupPadding', preChat.messagePopup.padding);
    root.documentElement.style.setProperty(
        '--messagePopupFontFamily',
        preChat.messagePopup.font.family
    );
    root.documentElement.style.setProperty(
        '--messagePopupFontSize',
        preChat.messagePopup.font.size
    );
    root.documentElement.style.setProperty(
        '--messagePopupFontColor',
        preChat.messagePopup.font.color
    );
    root.documentElement.style.setProperty(
        '--messagePopupCloseIconHeight',
        preChat.messagePopup.closeIconSize.height
    );
    root.documentElement.style.setProperty(
        '--messagePopupCloseIconWidth',
        preChat.messagePopup.closeIconSize.width
    );
    root.documentElement.style.setProperty(
        '--messageCounterCounterRight',
        preChat.messageCounter.counterRight
    );
    root.documentElement.style.setProperty(
        '--messageCounterCounterTop',
        preChat.messageCounter.counterTop
    );
    root.documentElement.style.setProperty(
        '--messagePopupBorderWidth',
        preChat.messagePopup.borderWidth
    );
    root.documentElement.style.setProperty(
        '--messagePopupBackgroundColor',
        preChat.messagePopup.backgroundColor
    );
    if (preChatObject.rdThemeSettings.questionType.qTQuestion) {
        root.documentElement.style.setProperty(
            '--messagePopupHighlightColor',
            preChatObject.rdThemeSettings.questionType.qTQuestion
        );
        root.documentElement.style.setProperty(
            '--qTButton',
            preChatObject.rdThemeSettings.questionType.qTQuestion
        );
        root.documentElement.style.setProperty(
            '--qTButtonText',
            preChat.messagePopup.lowLightColor
        );
    } else {
        root.documentElement.style.setProperty(
            '--messagePopupHighlightColor',
            preChat.messagePopup.highLightColor
        );
        root.documentElement.style.setProperty(
            '--qTButton',
            preChat.messagePopup.highLightColor
        );
        root.documentElement.style.setProperty(
            '--qTButtonText',
            preChat.messagePopup.lowLightColor
        );
    }

    root.documentElement.style.setProperty(
        '--messagePopupAgentNameFontColor',
        preChat.messagePopup.agentNameFontColor
    );
    root.documentElement.style.setProperty(
        '--messagePopupRdGlowTagColor',
        preChat.messagePopup.rdGlowTagColor
    );
    root.documentElement.style.setProperty(
        '--messagePopupLowLightColor',
        preChat.messagePopup.lowLightColor
    );
    root.documentElement.style.setProperty(
        '--messagePopupMainFontColor',
        preChat.messagePopup.mainFontColor
    );
    if (preChat.enableBranding && ApexChat.IsRoundedDynamicPlusTheme) {
        const brandSolid = preChatObject.rdThemeSettings.questionType.qTQuestion
        const visitorMsgBubble = `${brandSolid}66`
        const textColor = setTextColorBasedOnBg(brandSolid)
        const staticDark = "#020202";

        root.documentElement.style.setProperty('--messagePopupRdGlowTagColor', brandSolid);
        root.documentElement.style.setProperty('--onlineAgentTagColor', textColor);
        root.documentElement.style.setProperty('--sendBtnColor', textColor);
        root.documentElement.style.setProperty('--visitorFontColor', setTextColorBasedOnBg(visitorMsgBubble));
        root.documentElement.style.setProperty('--messagePopupLowLightColor', textColor);
        root.documentElement.style.setProperty('--headerFontColor', textColor);
        root.documentElement.style.setProperty('--hallowBtn', staticDark);
    }
};
export default setPrechatStyles;
